import {
  MELEE,
  CRITICAL_HIT,
  ARMOR_SLOTS,
  STRENGTH,
  FINESSE,
} from '../../character/content/templates';

export default function Attacking() {
  return (
    <>
      <h3 id="attack-rolls">ATTACK ROLLS</h3>
      <p>An <strong>Attack Roll</strong> is an action roll intended to inflict harm.
        The trait that applies to an Attack Roll is specified by the weapon or spell being used.
        Unarmed attack rolls use either {STRENGTH} or {FINESSE} (GM's choice). An Attack Roll's Difficulty,
        unless otherwise noted, is equal to the Difficulty score of its target.</p>

      <h3 id="damage-rolls">DAMAGE ROLLS</h3>
      <p>On a successful attack, roll damage. Damage is calculated from the <strong>damage roll</strong> listed in the
        attack's description with the format "xdy+[modifier]" (e.g., for a spell that inflicts "1d8+2" damage, you roll
        an eight-sided and add 2 to the result; the damage dealt is equal to the total).</p>
      <p>Any time an effect says to deal damage using your Spellcast trait, you roll a number of dice equal to your Spellcast trait.</p>
      <p className="rule-note">Note: If your Spellcast trait is +0 or lower, you don't roll anything.</p>
      <p>For weapons, the number of damage dice you roll is equal to your <strong>Proficiency</strong>.
        Note that your Proficiency multiplies the number of dice you roll, but doesn't affect the modifier.
        For example, a PC with Proficiency 2 and wielding a weapon with a damage rating of "d8+2" deals damage equal to "2d8+2" on a successful attack.</p>
      <p>Successful unarmed attacks inflict [Proficiency]d4 damage.</p>

      <h3 id="critical-damage">CRITICAL DAMAGE</h3>
      <p>When you get a {CRITICAL_HIT} (i.e., you roll matching values on your Duality Dice)
        on an Attack Roll, you deal extra damage. Make the damage roll as usual, but add the maximum possible result
        of the damage dice to the final total. For instance, if an attack would normally deal 2d8+1 damage, a {CRITICAL_HIT} would deal 2d8+1+16.</p>

      <h3 id="damage-types">DAMAGE TYPES</h3>
      <p>There are two damage types: <strong>physical damage (phy)</strong> and <strong>magic damage (mag)</strong>.
        Unless stated otherwise, mundane weapons and unarmed attacks deal physical damage, and spells deal magic damage.</p>

      <h3 id="resistance-immunity-direct-damage">RESISTANCE, IMMUNITY, AND DIRECT DAMAGE</h3>
      <p>If a target has <strong>resistance</strong> to a damage type, then they reduce incoming damage of that
        type by half before comparing it to their Hit Point Thresholds. If the target has additional ways of reducing
        incoming damage, such as marking {ARMOR_SLOTS}, they apply the resistance effect first. The effects of multiple resistances to the same damage type do not stack.</p>
      <p>If a target has <strong>immunity</strong> to a damage type, they ignore incoming damage of that type.</p>
      <p>If an Attack Roll deals both physical and magic damage, a character can only
        benefit from resistance or immunity if they are resistant or immune to both damage types.</p>
      <p><strong>Direct damage</strong> is damage that can't be reduced by marking {ARMOR_SLOTS}.</p>

      <h3 id="multi-target-attack-rolls">MULTI-TARGET ATTACK ROLLS</h3>
      <p>If a spell or ability allows you to target multiple adversaries, make one Attack Roll and one damage roll, then apply the results to each target individually.</p>

      <h3 id="multiple-damage-sources">MULTIPLE DAMAGE SOURCES</h3>
      <p>Damage dealt simultaneously from multiple sources is always totaled before it's compared to its target's damage thresholds.</p>
      <p className="rule-note">For example, if a PC with orc ancestry makes a successful Attack Roll against a target in {MELEE} range and decides to spend a Hope to use their "Tusks" feature (which gives them an extra 1d6 damage on a damage roll), they would roll their normal weapon damage and add a d6 to the result, then deal that total damage to the adversary.</p>
    </>
  );
}
